import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  selectPrefix,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setreportsFromDate,
  setreportsTodate,
} from "../../utility/Redux/profile";
import { FromToDate } from "../../utility/component/fromToDate";
import CustomerMasterHelp from "../../help/customermasterHelp";
import { GetPurchaseSummary } from "./func";
import { selectToken } from "../../utility/Redux/security";
import AccountMasterHelp from "../../help/listAccountMasterHelp";
import { PurchaseSummaryColumns } from "./columns";
import Footer from "./footer";
import { useReactToPrint } from "react-to-print";
import GeniusTableReports from "../../utility/component/geniusComponents/geniusTableData";
import PrintWithFooter from "../../utility/component/datagrid/printReportWithFooter";
import { PrintPurchaseSummaryColumns } from "./printColumns";
import IsLocalData from "../../utility/component/isLocalData";
import FromToDateMobile from "../../utility/component/fromToDateMobile";
import { DepartmentMasterHelp } from "../../help";
import NewPrintReport from "../../utility/component/datagrid/newPrintReport";
import { FormatNumber2 } from "../../utility/functions/formatNumber";

const ReciveSummary = () => {
  const prefix = useSelector(selectPrefix);
  const [purchaseList, setPurchaseList] = useState([]);
  const fromDate = useSelector(selectreportFromDate);
  const ToDate = useSelector(selectreportToDate);
  const width = useSelector(selectWidth);
  const [getCustomerData, setCustomerData] = useState({
    table_prefix: prefix,
    FDATE: moment(fromDate).format("YYYY-MM-DD"),
    TDATE: moment(ToDate).format("YYYY-MM-DD"),
    DEP_NAME: "",
    MOBILE: "",
  });
  const columns = PurchaseSummaryColumns(width);
  const printColumns = PrintPurchaseSummaryColumns(width);
  const [partyHelpStatus, setPartyHelpStatus] = useState(false);
  const printRef = useRef(null);
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const okButton = () => {
    GetPurchaseSummary(
      {
        table_prefix: prefix,
        FDATE: moment(fromDate).format("YYYY-MM-DD"),
        TDATE: moment(ToDate).format("YYYY-MM-DD"),
        DEP_NAME: getCustomerData.DEP_NAME ? getCustomerData.DEP_NAME : "",
      },
      token,
      dispatch,
      setPurchaseList
    );
  };
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  useEffect(() => {
    const callback = (details, data) => {
      setCustomerData(details[0]);
      setPurchaseList(data);
      dispatch(setreportsFromDate(details[0].FDATE));
      dispatch(setreportsTodate(details[0].TDATE));
    };
    const elseFunc = () => {};
    IsLocalData("recieve_summary", callback, elseFunc);
  }, []);

  return (
    <div className=" bg-white flex flex-col h-full w-full overflow-y-scroll">
      <div className=" flex flex-col h-full p-3  w-full">
        <div>
          {window.innerWidth <= 1000 ? (
            <>
              <FromToDateMobile
                departmentData={{
                  DEP_NAME: getCustomerData.DEP_NAME,
                }}
                onPrintClick={handlePrint}
                submit={okButton}
                onDepartmentClick={(e) => setPartyHelpStatus(true)}
                departmentClear={() => {
                  setCustomerData((e) => {
                    return {
                      ...e,
                      table_prefix: prefix,
                      FDATE: moment(fromDate).format("YYYY-MM-DD"),
                      TDATE: moment(ToDate).format("YYYY-MM-DD"),
                      DEP_NAME: "",
                    };
                  });
                  setPurchaseList([]);
                }}
              />
            </>
          ) : (
            <FromToDate
              onPrintClick={handlePrint}
              departmentData={{
                DEP_NAME: getCustomerData.DEP_NAME,
              }}
              hideReset
              submit={okButton}
              onDepartmentClick={(e) => setPartyHelpStatus(true)}
              departmentClear={() => {
                setCustomerData((e) => {
                  return {
                    ...e,
                    table_prefix: prefix,
                    FDATE: moment(fromDate).format("YYYY-MM-DD"),
                    TDATE: moment(ToDate).format("YYYY-MM-DD"),
                    DEP_NAME: "",
                  };
                });
                setPurchaseList([]);
              }}
            />
          )}
        </div>

        <div
          style={{ height: `calc(100% - 0px)`, width: "100%", marginTop: 6 }}
          className=" mb-2 "
        >
          {purchaseList[0] ? (
            <GeniusTableReports
              columns={columns}
              data={purchaseList}
              footer={<Footer columns={columns} rows={purchaseList} />}
            />
          ) : (
            <div className="h-full flex justify-center items-center text-sm text-gray-400 border mt-3 rounded-sm">
              No Records Found
            </div>
          )}
        </div>

        <div>
          <div
            style={{
              display: "none",
            }}
          >
            <div ref={printRef}>
              <NewPrintReport
                details={[
                  {
                    name: "From Date",
                    value: moment(fromDate).format("DD/MM/YYYY"),
                  },
                  {
                    name: "To Date",
                    value: moment(ToDate).format("DD/MM/YYYY"),
                  },
                  {
                    name: "Department",
                    value: getCustomerData.DEP_NAME,
                  },
                ]}
                title={"Recieve Summary"}
                data={purchaseList}
                columns={printColumns}
                footer={
                  <Footer
                    isFeilds={
                      <div className="flex justify-end text-sm mt-2">
                        <div>
                          <div className="flex ">
                            <div className="font-semibold w-[160px] text-right ">
                              Total Amount :
                            </div>
                            <div className="ml-2 flex flex-1 justify-end ">
                              {FormatNumber2(
                                purchaseList.reduce(
                                  (acc, row) => acc + Number(row.TOTAL),
                                  0
                                )
                              )}
                            </div>
                          </div>

                          <div className="flex">
                            <div className="font-semibold w-[160px]   text-right">
                              Total Return Amount :
                            </div>
                            <div className="ml-2">
                              {FormatNumber2(
                                purchaseList.reduce(
                                  (acc, row) => acc + Number(row.RTOTAL),
                                  0
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    columns={printColumns}
                    rows={purchaseList}
                  />
                }
              />
            </div>
          </div>
        </div>
      </div>
      <DepartmentMasterHelp
        onRowClick={(e) => {
          setCustomerData((c) => {
            return {
              ...c,
              DEP_NAME: e.row.DEP_NAME,
            };
          });
          setPartyHelpStatus(false);
        }}
        status={partyHelpStatus}
        onClose={() => {
          setPartyHelpStatus(false);
        }}
      />
    </div>
  );
};

export default ReciveSummary;
